const recipeReviewCache = new Map();
const TTL = 24 * 60 * 60 * 1000; // 1 Tag in Millisekunden

export function getCachedReview(key: string) {
  const entry = recipeReviewCache.get(key);
  if (!entry) return null;
  const isExpired = Date.now() - entry.timestamp > TTL;
  return isExpired ? null : entry.data;
}

//TODO: type this
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setCachedReview(key: string, data: any) {
  recipeReviewCache.set(key, { data, timestamp: Date.now() });
}

export function invalidateReviewCache(recipeId: number) {
  for (const key of recipeReviewCache.keys()) {
    if (key.includes(`"recipeId":"${recipeId}"`)) {
      recipeReviewCache.delete(key);
    }
  }
}
